module.exports = __webpack_public_path__ + "static/media/Trans_cab.5769651f.png";